var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.$store.state.displayType === "textual"
    ? _c("default-textual-section", {
        staticClass: "menu--section-pancho__willies",
        attrs: {
          menu: _vm.menu,
          section: _vm.section,
          "menu-item-component": "pancho-willies-food-item",
        },
      })
    : _c("default-visual-section", {
        staticClass: "menu--section-pancho__willies",
        attrs: {
          menu: _vm.menu,
          section: _vm.section,
          "menu-item-component": "pancho-willies-food-item",
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }